export default {
  setTwoFactor(state, payload) {
    state.VerifyTwoFactor = { ...payload.VerifyTwoFactor };
  },
  setTwoFactorNull(state) {
    state.VerifyTwoFactor = null;
  },
};